import { RDGrazing } from '@cibo/core'
import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { DetailPanel } from '../DetailPanel'
import { GrazingPanelTable } from './GrazingPanelTable'

export const GrazingPanel = () => {
  const { t } = useTranslation('@cibo/landmanager/GrazingPanel')

  return (
    <DetailPanel<RDGrazing>
      title={t('grazing')}
      traitId="grazing"
      DetailTable={GrazingPanelTable}
      DetailIndividual={({ currentYearData }: { currentYearData?: RDGrazing }) => (
        <Stack>
          {currentYearData?.result === undefined ? (
            <Typography variant="subtitle1">--</Typography>
          ) : (
            <>
              <Typography variant="subtitle1">
                {!!currentYearData?.input?.events
                  ? t('grazingEvents', {
                      count: currentYearData.input.events.length,
                    })
                  : '--'}
              </Typography>
            </>
          )}
        </Stack>
      )}
    />
  )
}
